import { Typography } from '@oresundsbron/bridge-ui';
import { useTranslation } from 'next-i18next';

export const InfoItem = ({
  titleKey,
  value,
}: {
  titleKey: string;
  value: string | number;
}) => {
  const { t } = useTranslation(['bridgeStatus', 'common'], {
    nsMode: 'fallback',
  });

  return (
    <Typography className="col-span-2 flex flex-col sm:col-span-3">
      <Typography as="span" intent="label" size="lg">
        {t(titleKey)}
      </Typography>
      <Typography as="span" intent="body" weight="medium">
        {value}
      </Typography>
    </Typography>
  );
};
